import isNil from 'lodash/isNil';
import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {TopSection as TopSectionType} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function Top({section, children}: CommonSectionProps) {
  const {ref, inView, entry} = useInView();
  const topSection = section as Omit<TopSectionType, 'groups'>;
  const isRecommendedItems = topSection.isRecommendedItems;
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
          ...(!isNil(isRecommendedItems) && {
            helix_yn: isRecommendedItems ? 'y' : 'n',
          }),
        },
        viewimp_contents: {
          imp_provider: isRecommendedItems ? 'helix' : 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView, isRecommendedItems]);
  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        click: {layer1: 'TOP', imp_id: 'stop'},
        viewimp_contents: {
          layer1: 'TOP',
          layer2: '빅배너',
          imp_id: 'stop',
          imp_type: 'vimp',
        },
        customProps: {
          section_type: 'TOP',
          ...(!isNil(isRecommendedItems) && {
            helix_yn: isRecommendedItems ? 'y' : 'n',
          }),
        },
      })}
    >
      {children}
    </div>
  );
}
